function convertCategories (categories) {

  const leaves = categories
    .filter(c => c.leaf === true)
    .map(c => {
      return {
        id: c.id,
        name: c.Name,
        type: c.Type,
        status: c.PublishStatus,
        version: c.Version,
        description: c.Description,
        createdDate: c.CreatedDate,
        modifiedDate: c.ModifiedDate,
      }
    })
    .sort((a, b) => a.name.localeCompare(b.name.toUpperCase()));

  const masterLeaf = {
    name: 'Master Leaf for Data Table',
    leaf: true,
    leaves: leaves.length ? leaves : [],
  };

  const noLeaves = categories
    .filter(c => c.leaf !== true)
    .map(c => {
      return {
        id: c.id,
        name: c.Name,
        description: c.Description,
        leaf: c.leaf,
        // children: c.Children,
        children: c.leaf ? null : [],
        // leaves: masterLeaf,
      }
    })
    .sort((a, b) => a.name.localeCompare(b.name.toUpperCase()));

  if (masterLeaf.leaves.length) {
    noLeaves.push(masterLeaf);
  }

  return noLeaves;
}

function createTree (tree, itemsArr) {
  tree.forEach(parentCat => {
    if (!parentCat.leaf) {
      const foundChildren = itemsArr.find(c => c.parentId === parentCat.id);
      if (foundChildren && foundChildren.items.length) {
        parentCat.children = foundChildren.items;
        createTree(foundChildren.items, itemsArr);
      }
    }
  });
}

export default {
  convertCategories,
  createTree
}